import styled from 'styled-components';

export const Footer = styled.div`
  margin-top: 20px;
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  padding: 30px 0;

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: 25px 0 5px 0;
  }
`;

export const InnerFooter = styled.div`
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
`;

export const FooterItem = styled.button`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.text.secondary};
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  border: none;
  background-color: transparent;

  a {
    align-items: center;
    display: inline-flex;
    text-decoration: none;
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  img {
    padding-right: 5px;
    width: 20px;
    height: 20px;
  }

  div {
    align-items: center;
    display: inline-flex;
    text-decoration: none;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export const IconWrapper = styled.div`
  padding-right: 5px;
  font-size: 1.25em;
`;
